/**
 * A translator built directly from a locale bundle, with no React or store
 * involved. Used by the two parity harnesses so both implementations get the
 * exact same strings for a given locale; the app itself uses `useTranslation`.
 */

import roMessages from "@/i18n/locales/ro.json";
import enMessages from "@/i18n/locales/en.json";
import type { Translator } from "./types";

type Messages = Record<string, unknown>;

function lookup(messages: Messages, key: string): string | undefined {
  const value = key.split(".").reduce<unknown>(
    (node, part) => (node && typeof node === "object" ? (node as Messages)[part] : undefined),
    messages,
  );
  return typeof value === "string" ? value : undefined;
}

export function createMessageTranslator(locale: string): Translator {
  const messages = (locale === "en" ? enMessages : roMessages) as Messages;
  return (key, params) => {
    const template = lookup(messages, key);
    if (template === undefined) return key;
    if (!params) return template;
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, name: string) => String(params[name] ?? ""));
  };
}
